import { FilterRestrictions } from './FilterRestrictions';

export default FilterRestrictions;
